import { Quote, Shell, Content, CustomerArea, Offline } from './scenes';
import * as React from 'react';
import steps from './scenes/Quote/steps';
import { IBrandingState } from './services/branding/models';
import { ICustomer } from './data/api/models';
import { Route, Switch } from 'react-router';
import PageNotFound from './scenes/Content/scenes/PageNotFound';

interface IAppProps {
  branding: IBrandingState;
  customer?: ICustomer;
}

export default ({ branding, customer }: IAppProps) => {
  const quoteSteps = steps(branding.channel);
  const customerArea = <CustomerArea key={1} steps={quoteSteps} channel={branding.channel} />;
  const quote = <Quote key={2} steps={quoteSteps} channel={branding.channel} customer={customer} />;
  const content = <Content steps={quoteSteps} />;
  const pageNotFound = <PageNotFound />;

  // TODO: Dynamically add in <Route /> with known URLs so that Quote and Content are not on every single page.

  const routes = (
    <Switch>
      <Route path="/auth">{customerArea}</Route>
      <Route path="/account">{customerArea}</Route>
      <Route path="/password">{customerArea}</Route>
      <Route path="/">
        <div>
          {quote}
          {content}
        </div>
      </Route>
      <Route path="*">{pageNotFound}</Route>
    </Switch>
  );

  return (
    <Shell steps={quoteSteps} channel={branding.channel}>
      {branding.isOffline ? <Offline /> : routes}
    </Shell>
  );
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/index.tsx